import { render, staticRenderFns } from "./onboardClinic.vue?vue&type=template&id=7803663a&scoped=true&"
import script from "./onboardClinic.vue?vue&type=script&lang=js&"
export * from "./onboardClinic.vue?vue&type=script&lang=js&"
import style0 from "./onboardClinic.vue?vue&type=style&index=0&id=7803663a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7803663a",
  null
  
)

export default component.exports